import { Platform } from 'react-native';

export const isAndroid5 = () => {
  return Platform.OS === 'android' && Platform.Version === 21;
};

export const isAndroid6 = () => {
  return Platform.OS === 'android' && Platform.Version === 23;
};

export const isAndroid8 = () => {
  return Platform.OS === 'android' && [26, 27].some(x => x == Platform.Version);
};

/**
 * Verifica se o dispositivo usa o modo edge-to-edge do Android (Android 15+)
 * onde o conteúdo pode ser exibido atrás dos recortes e bordas da tela.
 * @see {@link https://developer.android.com/develop/ui/views/layout/edge-to-edge|Documentação oficial do Android}
 */
export const isEdgeToEdge = () => {
  return Platform.OS === 'android' && Platform.Version >= 35;
};
